// dev なりすましログインの管理（ローカル開発専用）。
// localStorage に保存した email を API リクエストの x-dev-user ヘッダに載せる。
// 本番（Cloudflare Access）では未設定のままで、Access のヘッダが使われる。

const DEV_USER_KEY = "dev_user";

// 開発用に切り替えられるユーザー一覧（seed と対応）。二段階承認を体験できる構成。
export const DEV_USERS: { email: string; label: string }[] = [
  { email: "staff.brand@example.com", label: "商品事業處・品牌授權策略組・承辦人" },
  { email: "lead.brand@example.com", label: "商品事業處・品牌授權策略組・組長" },
  { email: "head.product@example.com", label: "商品事業處・處長" },
  { email: "staff.mkt@example.com", label: "整合行銷處・數位行銷組・承辦人" },
  { email: "lead.mkt@example.com", label: "整合行銷處・數位行銷組・組長" },
  { email: "head.mkt@example.com", label: "整合行銷處・處長" },
  { email: "secretariat@example.com", label: "事務局（駐在員）" },
  { email: "gm@example.com", label: "總經理（和幸）" },
];

export function getDevUser(): string {
  try {
    const stored = localStorage.getItem(DEV_USER_KEY);
    if (stored) return stored;
  } catch {
    /* noop */
  }
  // 未設定なら先頭ユーザーを既定にする。
  // この値は x-dev-user ヘッダとして常に送るが、サーバは ALLOW_DEV_LOGIN が有効で
  // かつ Access ヘッダが無いときだけ採用する。本番（Access＋フラグ未設定）では無視される。
  return DEV_USERS[0].email;
}

export function setDevUser(email: string): void {
  try {
    localStorage.setItem(DEV_USER_KEY, email);
  } catch {
    /* noop */
  }
}
